<template>
    <div class="products" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Products
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left" v-if="canModify">
                        <button type="button" class="btn btn-success" @click="open(null)" :disabled="loading">
                            Create Product
                        </button>
                    </div>
                </div>
            </legend>

            <div class="list-group" v-if="canModify">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === product.id}"
                   v-for="product in products"
                   :key="product.id"
                   @click="open(product.id)">
                    <h4 class="list-group-item-heading">
                        {{product.title}} <span v-html="product.typeLabel"></span> <span v-if="product.upgrades_available" class="label label-default">Upgrades Available</span>
                    </h4>

                    <p class="margin-md-bottom">
                        {{product.description}}
                    </p>
                    <p v-if="product.upgrades_available">
                        <span v-if="product.upgrade_type === UPGRADE_TYPE_SUPPORT_PHONE">Upgrades available by calling {{displaySupportPhone}}</span>
                        <span v-else-if="product.upgrade_type === UPGRADE_TYPE_LINK">Upgrades available <a target="_blank" :href="product.upgrade_link">here</a></span>
                    </p>

                    <h5 class="text-bold" v-if="product.type !== 3">{{product.displayValue}}</h5>
                    <h5 class="text-bold" v-if="product.type === 0 && product.num_receivers > 0">{{ product.displayNumReceivers }}</h5>
                    <h5 class="text-bold" v-if="product.type === 0 && product.num_dvrs > 0">{{ product.displayNumDvrs }}</h5>
                </a>
            </div>

            <ul class="list-group" v-else>
                <li v-for="product in products" :key="product.id" class="list-group-item">
                    <h4 class="list-group-item-heading">
                        {{product.title}} <span v-html="product.typeLabel"></span>
                    </h4>

                    <p class="list-group-item-text margin-md-bottom">
                        {{product.description}}
                    </p>
                    <p v-if="product.upgrades_available">
                        <span v-if="product.upgrade_type === UPGRADE_TYPE_SUPPORT_PHONE">Upgrades available by calling {{displaySupportPhone}}</span>
                        <span v-else-if="product.upgrade_type === UPGRADE_TYPE_LINK">Upgrades available <a target="_blank" :href="product.upgrade_link">here</a></span>
                    </p>

                    <h5 class="text-bold" v-if="product.type !== 3">{{ product.displayValue }}</h5>
                    <h5 class="text-bold" v-if="product.type === 0 && product.num_receivers > 0">{{ product.displayNumReceivers }}</h5>
                    <h5 class="text-bold" v-if="product.type === 0 && product.num_dvrs > 0">{{ product.displayNumDvrs }}</h5>
                </li>
            </ul>
        </fieldset>

        <product ref="productComponent"
                 v-if="canModify"
                 :model-id="selectedModelId"
                 :project-id="projectId"
                 :support-phone="supportPhone"
                 @afterSave="afterSave">
            <span></span>
        </product>
    </div>
</template>

<script>
    import models from "./mixins/models";

    const UPGRADE_TYPE_SUPPORT_PHONE = 1;
    const UPGRADE_TYPE_LINK = 2;

    export default {
        mixins: [ models ],

        data() {
            return {
                UPGRADE_TYPE_LINK,
                UPGRADE_TYPE_SUPPORT_PHONE
            }
        },

        props: {
            projectId: {
                required: true,
                type: String
            },

            canModify: {
                required: true,
                type: Boolean
            },

            supportPhone: {
                required: true,
                type: String
            }
        },

        computed: {
            displaySupportPhone(){
                let displayPhone = this.supportPhone;
                if (displayPhone.length >= 10) {
                    displayPhone = `(${displayPhone.substring(displayPhone.length - 10, displayPhone.length - 7)}) ${displayPhone.substring(displayPhone.length - 7, displayPhone.length - 4)}-${displayPhone.substring(displayPhone.length - 4)}`
                }
                return displayPhone;
            },

            products(){
                return this.models;
            },

            url(){
                return '/api/products?project_id=' + this.projectId;
            },

            modelComponent(){
                return 'productComponent';
            },

            resourceKey(){
                return 'Products';
            },
        },

        methods: {}
    }
</script>
